// src/i18n/es/hotels.js
const hotels = {
    name: 'Hotel |||| Hoteles',
    title: 'Gestión de Hoteles',
    titles: {
        list: 'Hoteles',
        create: 'Nuevo Hotel',
        edit: 'Editar Hotel',
        show: 'Detalles del Hotel',
    },
    fields: {
        id: 'ID',
        name: 'Nombre',
        group: 'Grupo',
        groupId: 'Grupo',
        groupName: 'Grupo',
        address: 'Dirección',
        city: 'Ciudad',
        country: 'País',
        postalCode: 'Código Postal',
        phone: 'Teléfono',
        email: 'Email',
        defaultLanguage: 'Idioma por defecto',
        installationCode: 'Código de instalación',
        isActive: 'Activo',
        settings: 'Configuración',
        zones: 'Zonas',
        lockerCount: 'Total de taquillas',
        userCount: 'Usuarios',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
        users: 'Usuarios',
        lockers: 'Taquillas',
        status: 'Estado',
        
        // Reference fields and tag types
        title: 'Campos de Referencia',
        reference_fields: 'Campos de Referencia',
        supported_tag_types: 'Tipos de ID Soportados',
        no_reference_fields: 'No hay campos de referencia configurados. Haz clic en "Añadir" para crear uno.',
        no_tag_types_available: 'No hay tipos de ID disponibles. Contacta al administrador del sistema.',
        
        // Field form
        add_field: 'Añadir Campo',
        edit_field: 'Editar Campo',
        delete_field: 'Eliminar Campo',
        delete_field_confirm: '¿Estás seguro de que quieres eliminar el campo "{label}" ({key})?',
        delete_warning: 'Esta acción no se puede deshacer.',
        
        field_key: 'Clave del Campo',
        field_key_help: 'Identificador único (ej: "room_number", "guest_name")',
        field_label: 'Etiqueta',
        field_label_help: 'Texto que verán los usuarios',
        field_mandatory: 'Campo Obligatorio',
        field_order: 'Orden de Visualización',
        field_order_help: 'Los números más bajos aparecen primero',
        
        // Messages
        field_saved: 'Campo guardado correctamente',
        field_deleted: 'Campo eliminado correctamente',
        configuration_saved: 'Configuración guardada correctamente',
        error_saving: 'Error al guardar la configuración',
        field_key_required: 'La clave y etiqueta del campo son obligatorias',
        field_key_unique: 'La clave del campo debe ser única',
        
        // Tag types
        tag_type_system: 'Sistema',
        tag_type_manual: 'Manual',
        select_tag_types: 'Selecciona los tipos de ID que el hotel puede usar',
        
        // Branding fields
        primary_color: 'Color Principal',
        logo: 'Logo',
        
        // Custom texts fields
        language: 'Idioma',
        custom_texts: 'Textos Personalizados',
        text_key: 'Clave del Texto',
        text_value: 'Valor del Texto',
        
        // Additional HotelFields translations
        count: '%{current} de %{max} campos configurados',
        subtitle: 'Configura hasta 5 campos personalizados para información adicional',
        no_fields: 'No hay campos configurados',
        no_fields_description: 'Los campos de referencia permiten capturar información adicional personalizada',
        create_first_field: 'Crear primer campo',
        new_field: 'Nuevo campo',
        mandatory: 'Obligatorio',
        key: 'Clave',
        display_order: 'Orden de visualización',
        move_up: 'Mover arriba',
        move_down: 'Mover abajo',
        edit: 'Editar',
        delete: 'Eliminar',
        cancel: 'Cancelar',
        create: 'Crear',
        update: 'Actualizar',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        saved_success: 'Campos guardados con éxito',
        save_error: 'Error al guardar los campos',
        save_changes: 'Guardar cambios',
        load_error: 'Error al cargar los campos',
        label_required: 'El nombre del campo es obligatorio',
        key_required: 'La clave del campo es obligatoria',
        key_format_error: 'La clave debe empezar con letra minúscula y solo contener letras minúsculas, números y guiones bajos',
        key_exists: 'Ya existe un campo con esa clave',
        label_helper: 'Nombre visible para los usuarios',
        key_helper: 'Identificador único (solo minúsculas, números y guiones bajos)',
        max_fields_warning: 'No se pueden agregar más de 5 campos',
        max_fields_reached: 'Has alcanzado el límite máximo de 5 campos de referencia',
        unsaved_changes: 'Tienes cambios sin guardar',
        delete_confirm: '¿Estás seguro de que quieres eliminar el campo \'%{name}\'?',
        no_permissions_delete: 'No tienes permisos para eliminar campos',
    },
    
    alert_config: {
        title: 'Configuración de Alertas',
        subtitle: 'Gestiona los destinatarios y el nivel de severidad de las alertas del sistema',
        email_service_title: 'Configuración de Email Service',
        email_service_subtitle: 'Configura la integración con el servicio de notificaciones por email',
        
        // Severity levels
        debug: 'Debug',
        info: 'Información',
        warning: 'Advertencia',
        error: 'Error',
        critical: 'Crítico',
        
        // Form labels
        min_severity_label: 'Nivel Mínimo de Severidad',
        min_severity_help: 'Solo se enviarán notificaciones para alertas con este nivel de severidad o superior',
        recipients_title: 'Destinatarios de Alertas',
        email_label: 'Email',
        api_key_label: 'API Key',
        account_name_label: 'Nombre de la cuenta del servicio Roommatik Notify',
        account_name_placeholder: 'Nombre de la cuenta del servicio Roommatik Notify',
        template_title: 'Plantilla del email de envío de código QR',
        template_label: 'Seleccionar Plantilla',
        template_placeholder: 'Selecciona una plantilla',
        
        // Connection status
        connected: 'Conectado',
        no_connection: 'Sin conexión',
        untested: 'No probado',
        
        // Actions
        add: 'Agregar',
        save_config: 'Guardar Configuración',
        saving: 'Guardando...',
        update_api_key: 'Actualizar API Key',
        config_api_key: 'Configurar API Key',
        test_connection: 'Probar Conexión',
        testing: 'Probando...',
        continue_editing: 'Continuar editando',
        exit_without_saving: 'Salir sin guardar',
        loading: 'Cargando...',
        
        // Messages
        no_recipients: 'No hay destinatarios configurados',
        email_required: 'Ingresa un email',
        email_invalid: 'Email inválido',
        email_exists: 'Este email ya está en la lista',
        api_key_current_placeholder: '••••••••',
        api_key_placeholder: 'Ingresa la API Key',
        api_key_keep_help: 'Deja vacío para mantener la configuración actual',
        api_key_required_help: 'Requerido para habilitar el envío de emails',
        connection_warning: 'La API Key está guardada pero no se pudo verificar la conexión. Los emails no se enviarán hasta que se establezca una conexión válida.',
        
        // Success/Error messages
        load_error: 'Error al cargar la configuración',
        connection_success: 'Conexión exitosa',
        connection_failed: 'No se pudo conectar. Verifica tu API Key',
        connection_test_error: 'Error al probar conexión',
        api_key_saved: 'API Key guardada con éxito',
        connection_verified: 'Conexión verificada correctamente',
        api_key_saved_no_connection: 'API Key guardada pero sin conexión activa',
        api_key_save_error: 'Error al guardar API Key',
        template_updated: 'Plantilla actualizada con éxito',
        template_update_error: 'Error al actualizar plantilla',
        hotel_load_error: 'No se pudo cargar la información del hotel',
        
        // Dialog
        unsaved_changes_title: 'Cambios sin guardar',
        unsaved_changes_message: 'Los cambios realizados se perderán si sales sin guardar',
        unsaved_changes_question: '¿Estás seguro de que deseas salir sin guardar los cambios en la configuración de notificaciones?',
    },
    filters: {
        search: 'Buscar',
        search_placeholder: 'Nombre, dirección o código...',
        group: 'Grupo',
        all_groups: 'Todos los grupos',
        active_only: 'Solo activos',
        inactive_only: 'Solo inactivos',
        country: 'País',
        all_countries: 'Todos los países',
    },
    actions: {
        create: 'Nuevo Hotel',
        edit: 'Editar',
        edit_desc: 'Modificar información básica',
        delete: 'Eliminar',
        delete_desc: 'Eliminar permanentemente',
        activate: 'Activar',
        deactivate: 'Desactivar',
        manage_zones: 'Gestionar Zonas',
        manage_zones_desc: 'Configurar áreas del hotel',
        manage_texts: 'Textos HMI',
        manage_texts_desc: 'Personalización multiidioma',
        manage_notifications: 'Notificaciones',
        manage_notifications_desc: 'Alertas y reportes',
        manage_fields: 'Campos de Referencia',
        manage_fields_desc: 'Tipos de identificación',
        view_statistics: 'Ver estadísticas',
        view_stats: 'Ver Estadísticas',
        disable: 'Desactivar',
        configure: 'Configurar',
        upload_logo: 'Subir Logo',
        add_text: 'Añadir Texto',
        add_language: 'Añadir Idioma',
        export_data: 'Exportar datos',
        
        // New actions from HotelTexts.tsx
        back_to_config: 'Volver a configuración',
        change_logo: 'Cambiar',
        remove: 'Eliminar',
        saving: 'Guardando...',
        save_branding: 'Guardar Identidad',
        save_texts: 'Guardar textos',
        add_first_text: 'Añadir primer texto',
        delete_text: 'Eliminar texto',
        continue_editing: 'Continuar editando',
        exit_without_saving: 'Salir sin guardar',
        change_language: 'Cambiar idioma',
        checking: 'Verificando...',
        add_default_texts: 'Añadir textos por defecto',
    },
    messages: {
        no_hotels: 'No hay hoteles registrados',
        no_hotels_hint: 'Comienza creando tu primer hotel',
        loading: 'Cargando hoteles...',
        create_success: 'Hotel creado correctamente',
        update_success: 'Hotel actualizado correctamente',
        delete_success: 'Hotel eliminado correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar este hotel?',
        activate_success: 'Hotel activado correctamente',
        deactivate_success: 'Hotel desactivado correctamente',
        installation_code_copied: 'Código de instalación copiado',
        access_denied: 'No tienes permisos para ver los hoteles.',
       
    },
    validation: {
        name_required: 'El nombre del hotel es obligatorio',
        name_min_length: 'El nombre debe tener al menos 3 caracteres',
        name_max_length: 'El nombre no puede exceder 100 caracteres',
        name_exists: 'Ya existe un hotel con este nombre',
        address_max_length: 'La dirección no puede exceder 255 caracteres',
        installation_code_required: 'El código de instalación no puede estar vacío',
        installation_code_max_length: 'El código de instalación no puede exceder 50 caracteres',
        installation_code_exists: 'Ya existe un hotel con este código de instalación',
        invalid_language: 'Idioma no válido',
        group_required: 'Debe seleccionar un grupo',
        email_format: 'El formato del email no es válido',
        phone_format: 'El formato del teléfono no es válido',
        installation_code_format: 'El código de instalación no es válido',
        email_duration: 'Debe estar entre 1 y 168 horas',
        code_expiration: 'Debe estar entre 5 y 1440 minutos',
        locker_hold: 'Debe estar entre 5 y 120 minutos',
        email_duration_required: 'La duración del email es obligatoria',
        email_duration_range: 'Debe estar entre 1 y 168 horas',
        code_expiration_required: 'La expiración del código es obligatoria',
        code_expiration_range: 'Debe estar entre 5 y 1440 minutos',
    },
    dialogs: {
        delete_title: 'Eliminar Hotel',
        delete_message: '¿Está seguro de que desea eliminar el hotel %{name}?',
        delete_warning: 'Esta acción eliminará todas las zonas, taquillas y asignaciones asociadas.',
        delete_cascade_warning: 'Esta acción eliminará todas las zonas, taquillas y asignaciones asociadas.',
        deactivate_title: 'Desactivar Hotel',
        deactivate_message: '¿Está seguro de que desea desactivar el hotel %{name}?',
        add_text_title: 'Añadir Texto Personalizado',
        
        // New dialogs from HotelTexts.tsx
        add_language_title: 'Añadir Nuevo Idioma',
        unsaved_changes_title: 'Cambios sin guardar',
        unsaved_changes_warning: 'Los cambios realizados se perderán si sales sin guardar',
        unsaved_both: 'Tienes cambios sin guardar tanto en los textos como en la identidad visual.',
        unsaved_texts: 'Tienes cambios sin guardar en los textos personalizados.',
        unsaved_branding: 'Tienes cambios sin guardar en la identidad visual.',
        confirm_exit: '¿Estás seguro de que deseas salir?',
        unsaved_language_warning: 'Tienes cambios sin guardar en el idioma actual',
        change_language_title: 'Cambiar idioma',
        change_language_message: 'Si cambias de idioma, perderás los cambios realizados en los textos del idioma %{selectedLanguage}. ¿Deseas continuar?',
    },
    tabs: {
        general: 'Información General',
        configuration: 'Configuración',
        zones: 'Zonas',
        lockers: 'Taquillas',
        statistics: 'Estadísticas',
        settings: 'Ajustes',
    },
    settings: {
        title: 'Configuración del Hotel',
        notifications: {
            title: 'Notificaciones',
            email: 'Email de notificaciones',
            types: 'Tipos de notificaciones',
        },
        locker_settings: {
            title: 'Configuración de Taquillas',
            auto_release_hours: 'Horas para liberación automática',
            allow_multiple: 'Permitir asignaciones múltiples',
            require_guest_info: 'Requerir información del huésped',
        },
        customization: {
            title: 'Personalización',
            logo: 'Logo del hotel',
            primary_color: 'Color primario',
            secondary_color: 'Color secundario',
        },
    },
    status: {
        active: 'Activo',
        inactive: 'Inactivo',
    },
    sections: {
        basic_info: 'Información Básica',
        basic_info_subtitle: 'Datos principales del hotel',
        basic_info_create_subtitle: 'Datos principales del nuevo hotel',
        operation_mode: 'Modo de Operación',
        operation_mode_subtitle: 'Configuración del sistema de acceso',
        timing_config: 'Configuración de Tiempos',
        tag_types: 'Tipos de ID Soportados',
        tag_types_subtitle: 'Tipos de identificación que acepta este hotel',
        branding: 'Identidad Visual',
        branding_subtitle: 'Personaliza el logo y color principal del hotel',
        custom_texts: 'Textos Personalizados',
        custom_texts_subtitle: 'Personaliza los textos de la interfaz en múltiples idiomas',
    },
    help: {
        name: 'Nombre único que identifica al hotel',
        group: 'Grupo al que pertenece el hotel',
        address: 'Dirección física del hotel',
        installationCode: 'Formato: TAyy1234',
        defaultLanguage: 'Idioma por defecto para las interfaces del hotel',
        select_tag_types: 'Selecciona los tipos de ID que el hotel puede usar para el acceso a las taquillas',
        operationMode: 'Modo de funcionamiento del sistema de taquillas',
        emailAssignmentDuration: 'Tiempo de validez de las asignaciones por email',
        codeExpiration: 'Tiempo de expiración de los códigos de acceso',
        lockerHold: 'Tiempo máximo que una taquilla puede estar reservada sin ser usada',
        primary_color: 'Color principal utilizado en la interfaz del huésped',
        logo: 'Logo que se mostrará en las interfaces del hotel (formato PNG/JPG)',
        text_key: 'Formato: categoria.nombre_texto (ej: button.submit)',
    },
    notes: {
        after_create: 'Después de crear el hotel, podrás configurar zonas, asignar taquillas y gestionar usuarios.',
    },
    placeholders: {
        select_group: 'Seleccionar grupo',
        name: 'Ingrese el nombre del hotel',
        address: 'Ingrese la dirección del hotel',
        installationCode: 'TAyy1234',
        search_texts: 'Buscar textos...',
    },
    labels: {
        no_group: 'Sin grupo',
    },
    select_group: 'Seleccionar grupo',
    no_groups: ' ',
    notifications: {
        created: 'Hotel creado con éxito',
        deleted: 'Hotel eliminado con éxito',
        load_config_error: 'Error al cargar la configuración del hotel',
        tag_selection_required: 'Debe seleccionar al menos un tipo de ID para el modo Tag Only',
        general_config_updated: 'Configuración general actualizada con éxito',
        hotel_updated: 'Hotel actualizado con éxito',
        texts_saved: 'Textos guardados con éxito',
        texts_save_error: 'Error al guardar los textos',
        brand_config_saved: 'Configuración de marca guardada con éxito',
        brand_config_error: 'Error al guardar la configuración de marca',
        text_key_empty: 'La clave del texto no puede estar vacía',
        text_key_exists: 'Esta clave ya existe',
        select_image_file: 'Por favor selecciona un archivo de imagen',
        file_size_limit: 'El archivo no debe superar los 2MB',
        fields_config_load_error: 'Error al cargar la configuración de campos',
        reference_fields_updated: 'Campos de referencia actualizados con éxito',
        reference_fields_save_error: 'Error al guardar los campos de referencia',
        max_fields_exceeded: 'No se pueden agregar más de 5 campos de referencia',
        field_name_required: 'El nombre del campo es obligatorio',
        field_key_required: 'La clave del campo es obligatoria',
        field_key_format_error: 'La clave debe empezar con letra minúscula y solo contener letras minúsculas, números y guiones bajos',
        field_key_exists: 'Ya existe un campo con esa clave',
        no_delete_permission: 'No tienes permisos para eliminar campos',
        notifications_config_load_error: 'Error al cargar la configuración de notificaciones',
        notifications_config_saved: 'Configuración de notificaciones guardada con éxito',
        notifications_config_save_error: 'Error al guardar la configuración',
        unsaved_changes: 'Cambios sin guardar',
        default_texts_added: 'Textos por defecto añadidos',
        texts_already_exist: 'Los textos ya existen',
        
    },
    
    // New sections from HotelTexts.tsx
    empty: {
        no_results: 'No se encontraron textos que coincidan con "%{searchText}"',
        no_texts: 'No hay textos configurados para este idioma',
    },
    
    info: {
        showing_filtered: 'Mostrando %{filteredCount} de %{totalCount} textos',
        total_texts: '%{count} textos configurados',
    },
    
    alerts: {
        tag_required: 'Se requiere una etiqueta',
    },
    
    errors: {
        create: 'Error al crear el hotel',
        ensure_texts_failed: 'Error al asegurar textos por defecto',
    },
    languages: {
        spanish: 'Español',
        english: 'English',
        french: 'Français',
        german: 'Deutsch',
        italian: 'Italiano',
        portuguese: 'Português',
    },
    zones: {
        title: 'Gestión de Zonas',
        subtitle: 'Organiza las taquillas en diferentes áreas del hotel',
        count: '%{count} zona configurada||||%{count} zonas configuradas',
        new_zone: 'Nueva Zona',
        edit_zone: 'Editar Zona',
        delete_zone: 'Eliminar Zona',
        zone_name: 'Nombre de la Zona',
        description: 'Descripción',
        order: 'Orden',
        order_help: 'Orden en que aparecerá la zona',
        cancel: 'Cancelar',
        create: 'Crear',
        update: 'Actualizar',
        saving: 'Guardando...',
        creating: 'Creando...',
        updating: 'Actualizando...',
        deleting: 'Eliminando...',
        delete_confirm: '¿Estás seguro de que quieres eliminar la zona %{name}?',
        delete_warning: 'Esta zona tiene %{count} taquillas asociadas. Eliminar la zona también eliminará estas asociaciones.',
        edit: 'Editar',
        delete: 'Eliminar',
        name_required: 'El nombre de la zona es obligatorio',
        name_exists: 'Ya existe una zona con ese nombre',
        created_success: 'Zona creada con éxito',
        updated_success: 'Zona actualizada con éxito',
        deleted_success: 'Zona eliminada con éxito',
        create_error: 'Error al crear la zona',
        update_error: 'Error al actualizar la zona',
        delete_error: 'Error al eliminar la zona',
        load_error: 'Error al cargar las zonas del hotel',
        no_permissions_create: 'No tienes permisos para crear zonas',
        no_permissions_edit: 'No tienes permisos para editar zonas',
        no_permissions_delete: 'No tienes permisos para eliminar zonas',
        no_permissions_save: 'No tienes permisos para guardar zonas',
        invalid_hotel_id: 'ID de hotel no válido',
        hotel_load_error: 'Error al cargar la información del hotel',
    },
};

export default hotels;